import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-editplot',
  templateUrl: './editplot.component.html',
  styleUrls: ['./editplot.component.css']
})
export class EditplotComponent implements OnInit {

  time: any;

  constructor() { 
    const date = new Date()
     const result = date.toLocaleDateString('th-TH', {
       year: 'numeric',
       month: 'long',
       day: 'numeric',
      //  hour: '2-digit',
      //  minute: '2-digit',
      //  second: '2-digit',
     })
     this.time = result;
   }

  ngOnInit(): void {

  }

}
